import axios from 'axios'
import fetch from '@/utils/fetch'
// const apiConfig = require('../../static/config.json')
const fileLoadPath =window.Glob.BASE_URL;
const apiUrl = window.Glob.BASE_URL;



//工作类型维护
export function getTaskList(data) {
  return fetch({
    url: apiUrl + '/api/Task/GetTaskList',
    method: 'post',
    data
  })
}
export function createTask(data) {
  return fetch({
    url: apiUrl + '/api/Task/CreateTask',
    method: 'post',
    data
  })
}
export function updateTask(data) {
  return fetch({
    url: apiUrl + '/api/Task/UpdateTask',
    method: 'post',
    data
  })
}

export function removeTask(data) {
  return fetch({
    url: apiUrl + '/api/Task/RemoveTask?id='+data,
    method: 'post'
  })
}

export function recoverTask(data) {
  return fetch({
    url: apiUrl + '/api/Task/RecoverTask?id='+data,
    method: 'post'
  })
}

export function getTask(data) {
  return fetch({
    url: apiUrl + '/api/Task/GetTask?id='+data,
    method: 'post'
  })
}
//工作类型维护结束


// WEBPACK FOOTER //
// ./src/api/taskApi.js